
























import { Component, Prop, Vue } from 'vue-property-decorator';
// import { Form } from 'element-ui';
@Component({
  name: 'lb-form'
  // components: {
  //   'el-form': Form
  // }
})
export default class extends Vue {
  @Prop() private model!: object;
  @Prop() private rules!: object;
  @Prop() private labelPosition!: string;
  @Prop() private labelWidth!: string;
  @Prop({ default: '' }) private labelSuffix!: string;
  @Prop({ type: Boolean, default: false }) private inline!: boolean;
  @Prop({ type: Boolean, default: false }) private inlineMessage!: boolean;
  @Prop({ type: Boolean, default: false }) private statusIcon!: boolean;
  @Prop({ type: Boolean, default: true }) private showMessage!: boolean;
  @Prop() private size!: string;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop({ type: Boolean, default: false }) private hideRequiredAsterisk!: boolean;

  private validate(callback: any) {
    // @ts-ignore
    this.$refs.lbForm.validate(callback);
  }

  private clearValidate(args?: any) {
    // @ts-ignore
    this.$refs.lbForm.clearValidate(args);
  }

  private validateField() {
    // @ts-ignore
    this.$refs.lbForm.validateField();
  }

  private resetFields() {
    // @ts-ignore
    this.$refs.lbForm.resetFields();
  }


}
